import { useState, useEffect } from 'react'
import {
  Center,
  Text,
  Box,
  FormControl,
  FormLabel,
  Input,
  Select,
  Heading,
  HStack,
  IconButton,
  Checkbox,
} from '@chakra-ui/react'
import { DatePicker } from 'antd'
import { search } from 'ss-search'
import moment from 'moment/moment'
import Table from 'components/Horizons/table'
import { FaFileExport } from 'react-icons/fa'
import axios from 'axios'
import { httpsCallable } from 'firebase/functions'
import { functions } from 'config/firebase'
import { useQuery } from 'react-query'
import { calculateAge, getKnowKids } from 'utils/kids'
import { checkNaN } from 'utils/checkNaN'

const createExcelReportSource = httpsCallable(functions, 'excelReportSource')
const getSourceReport = httpsCallable(functions, 'getSourceReport')

export function Source({ data, branches, managerBranchId }) {
  const columnsData = [
    {
      Header: 'วันที่ประเมิน',
      accessor: 'date',
      width: '20%',
      extra: (date) => moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
    },
    {
      Header: 'ชื่อ-นามสกุล',
      accessor: 'kid.name',
      width: '10%',
    },
    {
      Header: 'ชื่อเล่น',
      accessor: 'kid.nickname',
      width: '10%',
    },
    {
      Header: 'อายุ',
      accessor: 'kid.birthday',
      width: '10%',
      extra: (birthday) => {
        return birthday ? calculateAge(birthday) : '-'
      },
    },
    {
      Header: 'รู้จัก Kids Plus จาก',
      accessor: 'kid',
      width: '25%',
      extra: (kid) => {
        const knowKids = getKnowKids({
          kidKnow: kid?.know || {},
          kidFrom: kid?.from || '',
        })

        return knowKids
      },
    },
    {
      Header: 'จำนวนเงิน',
      accessor: 'evaluaton',
      width: '10%',
      extra: (evaluaton) => {
        return `${Number(evaluaton).toLocaleString('th-TH')} บาท`
      },
    },

    {
      Header: 'ผู้ประเมิน',
      accessor: 'details.staff',
      width: '10%',
    },
  ]
  const [searchQuery, setSearch] = useState({
    text: '',
    branch: managerBranchId || '',
    month: moment().format('YYYY-MM'),
  })
  // const [modalData, setModalData] = useState()
  const [downloadIsLoading, setDownloadIsLoading] = useState(false)

  // const { onOpen, isOpen, onClose } = useDisclosure()
  const { data: reportSource, isLoading } = useQuery(
    ['sourceReport', searchQuery?.month, searchQuery?.branch],
    async () => {
      const response = await getSourceReport({
        branchId: searchQuery?.branch,
        month: searchQuery?.month,
      })

      if (!response.data) {
        throw new Error('Network response was not ok')
      }
      return response.data
    },
    {
      refetchOnWindowFocus: false,
    }
  )
  const [dataQuery, setDataQuery] = useState({
    result: [],
    uniqueCourse: [],
  })
  const [tableData, setTableData] = useState([])
  const [isChecked, setIsChecked] = useState(false)

  // const sumEvaFee = useMemo(
  //   () =>
  //     dataQuery.reduce((sum, data) => {
  //       const evaluationFee = data?.evaluaton?.payment?.transactions?.reduce(
  //         (acc, val) => (val?.action === 'paid' ? acc + Number(val.paid) : acc),
  //         0
  //       )
  //       return sum + evaluationFee
  //     }, 0),
  //   [dataQuery]
  // )

  // const sumMemberFee = useMemo(
  //   () =>
  //     dataQuery.reduce((sum, data) => {
  //       if (data.logMember && data.status[0]) {
  //         return (
  //           sum +
  //           (data.status[0]?.payment[0]?.paid
  //             ? Number(data.status[0]?.payment[0]?.paid)
  //             : 0)
  //         )
  //       }
  //       return sum
  //     }, 0),
  //   [dataQuery]
  // )

  useEffect(() => {
    if (reportSource) {
      setDataQuery(reportSource)

      const filteredData = reportSource.result.filter(
        (_, index) =>
          index !== reportSource.result.length - 1 &&
          index !== reportSource.result.length - 2
      )
      setTableData(filteredData)
    }
  }, [reportSource])

  useEffect(() => {
    setSearch({
      ...searchQuery,
      month: isChecked
        ? [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
        : moment().format('YYYY-MM'),
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isChecked])

  async function handleDownloadFile({ data, uniqueCourse }) {
    setDownloadIsLoading(true)

    const dataExcel = data
      .map((d, index) => {
        return {
          ...d,

          no:
            index === data.length - 1 || index === data.length - 2
              ? ''
              : index + 1,
          details: {
            ...d.details,
            date: d.date
              ? moment(d.date, 'YYYY-MM-DD').format('DD/MM/YYYY')
              : '',
            age:
              index === data.length - 2
                ? `${Math.floor(
                    data[index].details.age /
                      data.filter(
                        (item, index) =>
                          index !== data.length - 1 &&
                          index !== data.length - 2 &&
                          checkNaN(item.details.age || 0) > 0
                      ).length || 1
                  )} ปี`
                : `${d.details.age} ปี`,
            knowKidsPlus: getKnowKids({
              kidKnow: d?.kid?.know || {},
              kidFrom: d?.kid?.from || '',
            }),
          },
        }
      })
      .filter((_, index) => index !== data.length - 1)

    createExcelReportSource(JSON.stringify({ data: dataExcel, uniqueCourse }))
      .then(async (i) => {
        const url = i.data.fileUrl
        const fileName = i.data.fileName
        await axios({
          url,
          method: 'GET',
          responseType: 'blob',
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${fileName}`)
            document.body.appendChild(link)
            link.click()
          })
          .catch((err) => {
            console.error(err)
            setDownloadIsLoading(false)
          })
        setDownloadIsLoading(false)
      })
      .finally(() => {
        setDownloadIsLoading(false)
      })
  }

  function handleSearch(e) {
    e.preventDefault()
    setSearch({ ...searchQuery, text: e.target.value })
    let textSearch = e.target.value
    const searchQueryArr = reportSource.result
    const searchKeys = ['kid.name', 'kid.nickname']
    const results = search(searchQueryArr, searchKeys, textSearch)
    const searchResults = textSearch === '' ? searchQueryArr : results
    setDataQuery((prev) => ({
      ...prev,
      result: searchResults,
    }))
  }

  return (
    <Box>
      {/* {isOpen && (
        <ModalItems isOpen={isOpen} onClose={onClose} data={modalData} />
      )} */}
      <Text color='brand'>Search</Text>

      <form onSubmit={handleSearch}>
        <Box
          borderWidth='1px'
          borderColor='brand'
          borderRadius='10px'
          p={5}
          mb={5}
          mt={1}
        >
          <HStack
            spacing={{ base: 0, md: '20px' }}
            flexDirection={{ base: 'column', sm: 'column', md: 'row' }}
          >
            <FormControl>
              <FormLabel>Search Name</FormLabel>
              <Input
                id='search'
                type='search'
                onChange={(e) => handleSearch(e)}
                value={searchQuery.text}
                placeholder='Search Name'
              />
            </FormControl>
            <FormControl>
              <FormLabel>Branch</FormLabel>
              <Select
                id='branch'
                placeholder='Pleas Select branch'
                onChange={(e) =>
                  setSearch({ ...searchQuery, branch: e.target.value })
                }
                value={searchQuery.branch}
                isDisabled={managerBranchId}
              >
                {branches
                  .sort(
                    (a, b) =>
                      b.accountType.localeCompare(a.accountType) ||
                      new Date(b.createdDate) - new Date(a.createdDate)
                  )
                  .map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.name}
                    </option>
                  ))}
              </Select>
            </FormControl>
            <FormControl>
              {/* <FormLabel>Month</FormLabel>
              <DatePicker
                allowClear={false}
                picker='month'
                format={'MMMM YYYY'}
                defaultValue={moment(searchQuery.month)}
                onChange={(date) =>
                  setSearch({
                    ...searchQuery,
                    month: moment(date).format('YYYY-MM'),
                  })
                }
              /> */}
              <HStack w='full' justifyContent='space-between'>
                <FormLabel>{isChecked ? 'Date' : 'Month'}</FormLabel>
                <Checkbox
                  colorScheme='lime'
                  onChange={(e) => {
                    setIsChecked(e.target.checked)
                    if (!e.target.checked) {
                      setSearch({
                        ...searchQuery,
                        month: [
                          moment().format('YYYY-MM-DD'),
                          moment().format('YYYY-MM-DD'),
                        ],
                      })
                    }
                  }}
                >
                  เลือกช่วงเวลา
                </Checkbox>
              </HStack>
              {isChecked ? (
                <DatePicker.RangePicker
                  allowClear={false}
                  format={'DD MMMM YYYY'}
                  value={[
                    moment(searchQuery?.month[0]),
                    moment(searchQuery?.month[1]),
                  ]}
                  onChange={(date) => {
                    setSearch({
                      ...searchQuery,
                      month: [
                        moment(date[0]).format('YYYY-MM-DD'),
                        moment(date[1]).format('YYYY-MM-DD'),
                      ],
                      text: '',
                    })
                  }}
                />
              ) : (
                <DatePicker
                  allowClear={false}
                  picker='month'
                  format={'MMMM YYYY'}
                  value={moment(searchQuery.month)}
                  onChange={(date) =>
                    setSearch({
                      ...searchQuery,
                      month: moment(date).format('YYYY-MM'),
                      text: '',
                    })
                  }
                />
              )}
            </FormControl>
            <HStack alignSelf={'end'}>
              <IconButton
                variant='outline'
                fontSize={'23px'}
                icon={<FaFileExport color='#8CC63E' />}
                onClick={() => {
                  handleDownloadFile({
                    data: dataQuery.result,
                    uniqueCourse: dataQuery.uniqueCourse,
                  })
                }}
                disabled={downloadIsLoading || !dataQuery.result?.length > 0}
                isLoading={downloadIsLoading}
              />
            </HStack>
          </HStack>
        </Box>
      </form>
      {searchQuery.branch !== '' ? (
        <>
          {/* <Stack
            my={5}
            p={{ base: 2, md: 5 }}
            borderWidth='1px'
            borderColor='brand'
            borderRadius='10px'
            w={{ base: 'full', lg: '35vw' }}
          >
            <HStack justifyContent='space-between'>
              <Heading size={{ base: 'sm', md: 'md' }}>Total Eva Fee</Heading>
              <Heading
                size={{ base: 'sm', md: 'md' }}
              >{`${sumEvaFee.toLocaleString()} บาท`}</Heading>
            </HStack>
            <HStack justifyContent='space-between'>
              <Heading size={{ base: 'sm', md: 'md' }}>
                Total Member Apply
              </Heading>
              <Heading
                size={{ base: 'sm', md: 'md' }}
              >{`${sumMemberFee.toLocaleString()} บาท`}</Heading>
            </HStack>
          </Stack> */}
          <Table
            columnsData={columnsData}
            tableData={tableData}
            noSearch
            loading={isLoading}
          />
        </>
      ) : (
        <Center>
          <Heading>Please Select Branch</Heading>
        </Center>
      )}
    </Box>
  )
}
